
import { FORMATTING_INSTRUCTIONS } from './formattingInstructions';

// Winning Aspiration stage templates

export const aspirationTemplates = {
  winningAspiration: `${FORMATTING_INSTRUCTIONS}

Objective: Define the Winning Aspiration for the {campaign_name} political campaign, informed by the political research and analysis.

You are a senior political strategist and campaign director. Conduct a comprehensive analysis to define what "winning" means for this {campaign_type} campaign, building on the political intelligence gathered.

Campaign Context:
- Issue: {political_issue}
- Target: {target_entity}
- Campaign Type: {campaign_type}
- Timeline: {campaign_timeline}
- Current Status: {current_status}
- Target Audience: {target_audience}

Research Context:
{previous_analysis}

Strategic Analysis Tasks:

1. VICTORY DEFINITION FRAMEWORK:
Define victory across multiple dimensions, informed by political realities:
- Primary Victory: The core political outcome that constitutes campaign success
- Secondary Victories: Important allied wins that support the primary goal
- Minimum Viable Victory: The least acceptable outcome representing progress
- Stretch Victory: Maximum possible achievement if conditions align perfectly
- Defensive Victory: Preventing worse outcomes or maintaining current position

2. SUCCESS METRICS AND INDICATORS:
Establish measurable indicators informed by political analysis:
- Quantitative Metrics: Policy changes, votes, commitments, mobilization numbers
- Qualitative Indicators: Narrative shifts, stakeholder position changes
- Timeline Milestones: Key decision points and pressure moments
- Early Warning Indicators: Signals of momentum or resistance
- Opposition Response Metrics: Counter-mobilization and defensive actions

3. MOVEMENT INTEGRATION STRATEGY:
Connect campaign to broader political and social movements:
- Union movement advancement: How victory strengthens worker power
- Coalition strengthening: Precedents for future collaborative campaigns
- Democratic participation: Expanding civic engagement and political access
- Policy precedent: Establishing favorable frameworks for future campaigns

4. STAKEHOLDER VALUE PROPOSITION:
Define what victory means for different stakeholder groups:
- Union Members: Direct benefits, precedent value, power building
- Political Allies: Shared victories, coalition strengthening, electoral benefits
- Target Constituencies: Concrete improvements and representation gains
- Opposition Management: Costs of resistance vs. accommodation incentives

5. POLITICAL FEASIBILITY ASSESSMENT:
Evaluate aspiration against political realities:
- Decision-maker positioning and influence strategies
- Opposition strength and counter-mobilization capacity
- Public opinion dynamics and persuasion opportunities
- Resource requirements vs. available capacity
- Timeline constraints and opportunity windows

6. THEORY OF VICTORY PREVIEW:
Outline how identified political dynamics create pathways to victory:
- Pressure point activation sequences
- Coalition mobilization strategies
- Opposition neutralization approaches
- Narrative dominance and frame setting
- Escalation pathways and tactical flexibility

Provide detailed, actionable victory definition with specific metrics and strategic rationale.
`
};
